export default "__VITE_ASSET__RdZRUDyn__"